<template>
  <div class="block-statistics">
    <Icone :is="mountedIcone" :module="icone"/>
    <div class="stats-year-wrapper">
      <StatisticaPerAnno :statisticaPerAnno="statisticaPerAnno" v-for="statisticaPerAnno in statistiche" v-if="statistiche.length > 0" />
    </div>
  </div>
</template>
<script>
  import ApiService from '@/services/api/ApiService.js';
  import axios from 'axios';
  import StatisticaPerAnno from '@/components/elements/StatisticaPerAnno.vue';

  export default {
    name: 'blocco_statistiche',
    props: ['module'],
    data() {
      return {
        mountedIcone: null,
        values: [],
        icone: [],
        statistiche: [],
      }
    },
    created() {
    },
    computed: {
      loader() {
        return () => import(`@/components/modules/icone`)
      },
    },
    mounted() {
      this.loader()
        .then(() => {
          ApiService.getRelationship(this.module.data.relationships.moduli.links.related).then(relationship => {
            this.icone.data = relationship.data['0'];

            relationship.data.forEach((elem, key) => {
              switch (elem.type) {
                case 'paragraph--statistiche_per_anno':
                  ApiService.getRelationship(elem.relationships.singole_statistiche.links.related).then(statRelationship => {
                    let data = {
                      title: elem.attributes.titolo,
                      stats: statRelationship,
                    };

                    this.statistiche.push(data);
                  })
                    .catch(error => console.log('error on blocco_statistiche paragraph--statistiche_per_anno getRelationship: ', error))
                    .finally(() => {
                    });
                  break;
              }
            });
          })
            .catch(error => console.log('error on blocco_statistiche getRelationship: ', error))
            .finally(() => {
              this.mountedIcone = () => this.loader();
            });

        })
        .catch(() => {
        })
    },
    components: {
      StatisticaPerAnno,
    }
  }
</script>
